import { EmptyAction, DataAction, ErrorAction } from './utils';
import { InternalShipmentGroup, ShipmentGroupConfiguration } from '../../models/shipment-group';
import { CreateShipmentGroupConfigurationInput, UpdateShipmentGroupConfigurationInput, DeleteShipmentGroupConfigurationInput } from '../../ports/ShipmentGroupService';

export enum ActionType {
  GET_INTERNAL_SHIPMENT_GROUPS_REQUEST = 'GET_INTERNAL_SHIPMENT_GROUPS/REQUEST',
  GET_INTERNAL_SHIPMENT_GROUPS_FAILURE = 'GET_INTERNAL_SHIPMENT_GROUPS/FAILURE',
  GET_INTERNAL_SHIPMENT_GROUPS_SUCCESS = 'GET_INTERNAL_SHIPMENT_GROUPS/SUCCESS',

  GET_SHIPMENT_GROUP_CONFIGURATIONS_REQUEST = 'GET_SHIPMENT_GROUP_CONFIGURATIONS/REQUEST',
  GET_SHIPMENT_GROUP_CONFIGURATIONS_FAILURE = 'GET_SHIPMENT_GROUP_CONFIGURATIONS/FAILURE',
  GET_SHIPMENT_GROUP_CONFIGURATIONS_SUCCESS = 'GET_SHIPMENT_GROUP_CONFIGURATIONS/SUCCESS',

  CREATE_SHIPMENT_GROUP_CONFIGURATION_REQUEST = 'CREATE_SHIPMENT_GROUP_CONFIGURATION/REQUEST',
  CREATE_SHIPMENT_GROUP_CONFIGURATION_FAILURE = 'CREATE_SHIPMENT_GROUP_CONFIGURATION/FAILURE',
  CREATE_SHIPMENT_GROUP_CONFIGURATION_SUCCESS = 'CREATE_SHIPMENT_GROUP_CONFIGURATION/SUCCESS',

  UPDATE_SHIPMENT_GROUP_CONFIGURATION_REQUEST = 'UPDATE_SHIPMENT_GROUP_CONFIGURATION/REQUEST',
  UPDATE_SHIPMENT_GROUP_CONFIGURATION_FAILURE = 'UPDATE_SHIPMENT_GROUP_CONFIGURATION/FAILURE',
  UPDATE_SHIPMENT_GROUP_CONFIGURATION_SUCCESS = 'UPDATE_SHIPMENT_GROUP_CONFIGURATION/SUCCESS',

  DELETE_SHIPMENT_GROUP_CONFIGURATION_REQUEST = 'DELETE_SHIPMENT_GROUP_CONFIGURATION/REQUEST',
  DELETE_SHIPMENT_GROUP_CONFIGURATION_FAILURE = 'DELETE_SHIPMENT_GROUP_CONFIGURATION/FAILURE',
  DELETE_SHIPMENT_GROUP_CONFIGURATION_SUCCESS = 'DELETE_SHIPMENT_GROUP_CONFIGURATION/SUCCESS',
}

export type GetInternalShipmentGroupsRequestAction =
  EmptyAction<ActionType.GET_INTERNAL_SHIPMENT_GROUPS_REQUEST>;
export type GetInternalShipmentGroupsSuccessAction =
  DataAction<ActionType.GET_INTERNAL_SHIPMENT_GROUPS_SUCCESS, InternalShipmentGroup[]>;
export type GetInternalShipmentGroupsFailureAction =
  ErrorAction<ActionType.GET_INTERNAL_SHIPMENT_GROUPS_FAILURE>;

export type GetInternalShipmentGroupsAction =
  GetInternalShipmentGroupsRequestAction |
  GetInternalShipmentGroupsSuccessAction |
  GetInternalShipmentGroupsFailureAction;

export type GetShipmentGroupConfigurationsRequestAction =
  EmptyAction<ActionType.GET_SHIPMENT_GROUP_CONFIGURATIONS_REQUEST>;
export type GetShipmentGroupConfigurationsSuccessAction =
  DataAction<ActionType.GET_SHIPMENT_GROUP_CONFIGURATIONS_SUCCESS, ShipmentGroupConfiguration[]>;
export type GetShipmentGroupConfigurationsFailureAction =
  ErrorAction<ActionType.GET_SHIPMENT_GROUP_CONFIGURATIONS_FAILURE>;

export type GetShipmentGroupConfigurationsAction =
  GetShipmentGroupConfigurationsRequestAction |
  GetShipmentGroupConfigurationsSuccessAction |
  GetShipmentGroupConfigurationsFailureAction;

export type CreateShipmentGroupConfigurationRequestAction =
  DataAction<ActionType.CREATE_SHIPMENT_GROUP_CONFIGURATION_REQUEST, CreateShipmentGroupConfigurationInput>;
export type CreateShipmentGroupConfigurationSuccessAction =
  DataAction<ActionType.CREATE_SHIPMENT_GROUP_CONFIGURATION_SUCCESS, ShipmentGroupConfiguration>;
export type CreateShipmentGroupConfigurationFailureAction =
  ErrorAction<ActionType.CREATE_SHIPMENT_GROUP_CONFIGURATION_FAILURE>;

export type CreateShipmentGroupConfigurationAction =
  CreateShipmentGroupConfigurationRequestAction |
  CreateShipmentGroupConfigurationSuccessAction |
  CreateShipmentGroupConfigurationFailureAction;

export type UpdateShipmentGroupConfigurationRequestAction =
  DataAction<ActionType.UPDATE_SHIPMENT_GROUP_CONFIGURATION_REQUEST, UpdateShipmentGroupConfigurationInput>;
export type UpdateShipmentGroupConfigurationSuccessAction =
  DataAction<ActionType.UPDATE_SHIPMENT_GROUP_CONFIGURATION_SUCCESS, ShipmentGroupConfiguration>;
export type UpdateShipmentGroupConfigurationFailureAction =
  ErrorAction<ActionType.UPDATE_SHIPMENT_GROUP_CONFIGURATION_FAILURE>;

export type UpdateShipmentGroupConfigurationGroupAction =
  UpdateShipmentGroupConfigurationRequestAction |
  UpdateShipmentGroupConfigurationSuccessAction |
  UpdateShipmentGroupConfigurationFailureAction;

export type DeleteShipmentGroupConfigurationRequestAction =
  DataAction<ActionType.DELETE_SHIPMENT_GROUP_CONFIGURATION_REQUEST, DeleteShipmentGroupConfigurationInput>;
export type DeleteShipmentGroupConfigurationSuccessAction =
  DataAction<ActionType.DELETE_SHIPMENT_GROUP_CONFIGURATION_SUCCESS, string>;
export type DeleteShipmentGroupConfigurationFailureAction =
  ErrorAction<ActionType.DELETE_SHIPMENT_GROUP_CONFIGURATION_FAILURE>;

export type DeleteShipmentGroupConfigurationAction =
  DeleteShipmentGroupConfigurationRequestAction |
  DeleteShipmentGroupConfigurationSuccessAction |
  DeleteShipmentGroupConfigurationFailureAction;

export type Action =
  | GetInternalShipmentGroupsAction
  | CreateShipmentGroupConfigurationAction
  | UpdateShipmentGroupConfigurationGroupAction
  | DeleteShipmentGroupConfigurationAction
  | GetShipmentGroupConfigurationsAction;

export const getInternalShipmentGroups = {
  request: (): GetInternalShipmentGroupsRequestAction => ({
    type: ActionType.GET_INTERNAL_SHIPMENT_GROUPS_REQUEST,
  }),
  failure: (error: string): GetInternalShipmentGroupsFailureAction => ({
    error,
    type: ActionType.GET_INTERNAL_SHIPMENT_GROUPS_FAILURE,
  }),
  success: (data: InternalShipmentGroup[]): GetInternalShipmentGroupsSuccessAction => ({
    data,
    type: ActionType.GET_INTERNAL_SHIPMENT_GROUPS_SUCCESS,
  }),
};

export const createShipmentGroupConfiguration = {
  request: (data: CreateShipmentGroupConfigurationInput): CreateShipmentGroupConfigurationRequestAction => ({
    data,
    type: ActionType.CREATE_SHIPMENT_GROUP_CONFIGURATION_REQUEST,
  }),
  failure: (error: string): CreateShipmentGroupConfigurationFailureAction => ({
    error,
    type: ActionType.CREATE_SHIPMENT_GROUP_CONFIGURATION_FAILURE,
  }),
  success: (data: ShipmentGroupConfiguration): CreateShipmentGroupConfigurationSuccessAction => ({
    data,
    type: ActionType.CREATE_SHIPMENT_GROUP_CONFIGURATION_SUCCESS,
  }),
};

export const updateShipmentGroupConfiguration = {
  request: (data: UpdateShipmentGroupConfigurationInput): UpdateShipmentGroupConfigurationRequestAction => ({
    data,
    type: ActionType.UPDATE_SHIPMENT_GROUP_CONFIGURATION_REQUEST,
  }),
  failure: (error: string): UpdateShipmentGroupConfigurationFailureAction => ({
    error,
    type: ActionType.UPDATE_SHIPMENT_GROUP_CONFIGURATION_FAILURE,
  }),
  success: (data: ShipmentGroupConfiguration): UpdateShipmentGroupConfigurationSuccessAction => ({
    data,
    type: ActionType.UPDATE_SHIPMENT_GROUP_CONFIGURATION_SUCCESS,
  }),
};

export const deleteShipmentGroupConfiguration = {
  request: (data: DeleteShipmentGroupConfigurationInput): DeleteShipmentGroupConfigurationRequestAction => ({
    data,
    type: ActionType.DELETE_SHIPMENT_GROUP_CONFIGURATION_REQUEST,
  }),
  failure: (error: string): DeleteShipmentGroupConfigurationFailureAction => ({
    error,
    type: ActionType.DELETE_SHIPMENT_GROUP_CONFIGURATION_FAILURE,
  }),
  success: (data: string): DeleteShipmentGroupConfigurationSuccessAction => ({
    data,
    type: ActionType.DELETE_SHIPMENT_GROUP_CONFIGURATION_SUCCESS,
  }),
};

export const getShipmentGroupConfigurations = {
  request: (): GetShipmentGroupConfigurationsRequestAction => ({
    type: ActionType.GET_SHIPMENT_GROUP_CONFIGURATIONS_REQUEST,
  }),
  failure: (error: string): GetShipmentGroupConfigurationsFailureAction => ({
    error,
    type: ActionType.GET_SHIPMENT_GROUP_CONFIGURATIONS_FAILURE,
  }),
  success: (data: ShipmentGroupConfiguration[]): GetShipmentGroupConfigurationsSuccessAction => ({
    data,
    type: ActionType.GET_SHIPMENT_GROUP_CONFIGURATIONS_SUCCESS,
  }),
};
